export default "__VITE_ASSET__D_DRfYTO__"